import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { unAuthorizedLogout } from "helpers/unauthorizedLogout";
import {
  HTTP_UNAUTHORIZED,
  PUBLIC_AUTH_ENDPOINTS,
} from "helpers/publicAuthConstants";

export const unauthenticatedMiddleware: Middleware =
  () =>
  (next) =>
  (action) => {
    if (
      isRejectedWithValue(action) &&
      (action.payload as { status?: number })?.status === HTTP_UNAUTHORIZED
    ) {
      const handledByBaseQuery = (action as {
        meta?: { baseQueryMeta?: { unauthorizedHandled?: boolean } };
      }).meta?.baseQueryMeta?.unauthorizedHandled;
      const endpointName = (action as { meta?: { arg?: { endpointName?: string } } })
        .meta?.arg?.endpointName;
      if (
        !handledByBaseQuery &&
        (!endpointName || !PUBLIC_AUTH_ENDPOINTS.has(endpointName))
      ) {
        unAuthorizedLogout();
      }
    }

    return next(action);
  };
